// ============================================================================
// Rush Store — الباقات الرسمية لنقاط CP
// السعر بالريال السعودي (SAR). الأسعار موحّدة لجميع أنواع الحسابات
// (خليجي / متوسط / أفريقي) عبر تحويل بنكي.
// ============================================================================

// ملاحظة: باقة 880 CP لا يتوفر لها رابط منتج بعد → link = null.
export const CP_PACKAGES = [
  {
    id: "cp_880",
    cp: 880,
    price: 39,
    name: "880 CP",
    image:
      "https://customer-assets.emergentagent.com/job_rushcp-marketplace/artifacts/sazc4x11_IMG_4457.jpeg",
    link: null,
  },
  {
    id: "cp_2400",
    cp: 2400,
    price: 88,
    name: "2400 CP",
    image:
      "https://customer-assets.emergentagent.com/job_rushcp-marketplace/artifacts/i8al525b_IMG_4458.jpeg",
    link: "https://salla.sa/rushcp.com/2400-نقاط-كول-اوف-ديوتي-موبايل-call-of-duty-mobile-cp/p1146048852",
  },
  {
    id: "cp_5000",
    cp: 5000,
    price: 175,
    name: "5000 CP",
    image:
      "https://customer-assets.emergentagent.com/job_rushcp-marketplace/artifacts/cdgdbsxt_IMG_4459.jpeg",
    link: "https://salla.sa/rushcp.com/5000-نقاط-كول-اوف-ديوتي-موبايل-call-of-duty-mobile-cp/p1157500906",
  },
  {
    id: "cp_5880",
    cp: 5880,
    price: 211.5,
    name: "5880 CP",
    image:
      "https://customer-assets.emergentagent.com/job_rushcp-marketplace/artifacts/h249ysmj_IMG_4460.jpeg",
    link: "https://salla.sa/rushcp.com/5880-نقاط-كول-اوف-ديوتي-موبايل-call-of-duty-mobile-cp/p976683866",
  },
  {
    id: "cp_7400",
    cp: 7400,
    price: 263,
    name: "7400 CP",
    image:
      "https://customer-assets.emergentagent.com/job_rushcp-marketplace/artifacts/geva8bmb_IMG_4462.jpeg",
    link: "https://salla.sa/rushcp.com/7400-نقاط-كول-اوف-ديوتي-موبايل-call-of-duty-mobile-cp/p835588523",
  },
  {
    id: "cp_10800",
    cp: 10800,
    price: 330,
    name: "10800 CP",
    image:
      "https://customer-assets.emergentagent.com/job_rushcp-marketplace/artifacts/okqbken8_IMG_4463.jpeg",
    link: "https://salla.sa/rushcp.com/10800-نقاط-كول-اوف-ديوتي-موبايل-call-of-duty-mobile-cp/p449996536",
  },
];

// طريقة الدفع الافتراضية
export const PAYMENT_METHOD = "تحويل بنكي";

// ============================================================================
// خوارزمية اقتراح أفضل التركيبات
// ----------------------------------------------------------------------------
// المدخل: neededCP → كمية CP المطلوب شراؤها (بعد خصم رصيد اللاعب).
// المخرج: قائمة من 3 اقتراحات (أو أقل، بدون تكرار نفس التركيبة):
//   - "cheapest"     : أقل سعر إجمالي بالريال.
//   - "least_excess" : أقل CP فائض بعد تغطية المطلوب.
//   - "least_items"  : أقل عدد باقات (وحدات) في السلة.
// عند تساوي معيار ما، المفاضلة بترتيب: (1) السعر (2) الفائض (3) عدد الباقات.
// يُسمح بتكرار نفس الباقة (مثلاً 2400 CP ×2).
// ============================================================================

const buildComboKey = (combo) =>
  Object.keys(combo)
    .filter((k) => combo[k] > 0)
    .sort()
    .map((k) => `${k}:${combo[k]}`)
    .join("|");

// المفاضلة الأساسية عند التساوي: (السعر ↑) ثم (الفائض ↑) ثم (عدد الوحدات ↑)
const tieBreak = (a, b) =>
  a.totalPrice - b.totalPrice ||
  a.excess - b.excess ||
  a.totalItems - b.totalItems;

const enumerateCombos = (neededCP, packages) => {
  // نُرتّب من الأكبر إلى الأصغر لتقليم الفروع بأسرع ما يمكن
  const sorted = [...packages].sort((a, b) => b.cp - a.cp);
  const combos = [];

  const recurse = (idx, currCP, currPrice, currItems, state) => {
    if (currCP >= neededCP) {
      // نُضيف تركيبة صالحة تُغطّي المطلوب
      const combo = { ...state };
      combos.push({
        combo,
        totalCP: currCP,
        totalPrice: Math.round(currPrice * 100) / 100,
        totalItems: currItems,
        excess: currCP - neededCP,
        key: buildComboKey(combo),
      });
      return;
    }
    if (idx >= sorted.length) return;

    const pkg = sorted[idx];
    const remaining = neededCP - currCP;
    // حد أقصى منطقي: ما يكفي لتغطية المتبقّي + وحدة واحدة إضافية
    const maxQty = Math.ceil(remaining / pkg.cp) + 1;
    for (let q = 0; q <= maxQty; q++) {
      state[pkg.id] = q;
      recurse(
        idx + 1,
        currCP + q * pkg.cp,
        currPrice + q * pkg.price,
        currItems + q,
        state
      );
    }
    delete state[pkg.id];
  };

  recurse(0, 0, 0, 0, {});
  return combos;
};

/**
 * suggestPackageCombos(neededCP, packages?)
 * يُعيد قائمة اقتراحات (0 إلى 2) مرتّبة كالتالي:
 *   1) الأرخص  → recommended = true
 *   2) الأقل عناصر
 * كل عنصر يحمل:
 *   { badges: string[], combo: [{pkg, qty, subtotal}], totalCP, totalPrice, excess, totalItems }
 * إذا كانت نفس التركيبة هي الأفضل في المعيارين، تُعرض مرة واحدة مع شارات متعددة.
 */
export const suggestPackageCombos = (neededCP, packages = CP_PACKAGES) => {
  const needed = Math.max(0, Math.floor(Number(neededCP) || 0));
  if (needed <= 0) return [];

  const combos = enumerateCombos(needed, packages);
  if (combos.length === 0) return [];

  // الفائز في كل معيار (تم حذف "الأقل فائضًا")
  const cheapest = [...combos].sort(tieBreak)[0];
  const leastItems = [...combos].sort(
    (a, b) =>
      a.totalItems - b.totalItems ||
      a.totalPrice - b.totalPrice ||
      a.excess - b.excess
  )[0];

  // نحفظ ترتيب الأولوية: cheapest > least_items
  const winners = [
    { badge: "cheapest", data: cheapest },
    { badge: "least_items", data: leastItems },
  ];

  const byKey = new Map();
  for (const w of winners) {
    if (!byKey.has(w.data.key)) {
      byKey.set(w.data.key, { ...w.data, badges: [w.badge] });
    } else {
      byKey.get(w.data.key).badges.push(w.badge);
    }
  }

  // نُعيد الترتيب بحسب أول شارة (يحفظ الأولوية)
  const priority = { cheapest: 0, least_items: 1 };
  const suggestions = [...byKey.values()].sort(
    (a, b) => priority[a.badges[0]] - priority[b.badges[0]]
  );

  // تحويل combo (map) إلى مصفوفة عناصر مع تفاصيل الباقة
  return suggestions.map((s) => {
    const items = Object.entries(s.combo)
      .filter(([, qty]) => qty > 0)
      .map(([id, qty]) => {
        const pkg = packages.find((p) => p.id === id);
        return {
          pkg,
          qty,
          subtotal: Math.round(pkg.price * qty * 100) / 100,
        };
      })
      .sort((a, b) => b.pkg.cp - a.pkg.cp);

    return {
      badges: s.badges,
      items,
      totalCP: s.totalCP,
      totalPrice: s.totalPrice,
      excess: s.excess,
      totalItems: s.totalItems,
    };
  });
};

export const BADGE_LABELS = {
  cheapest: "الأرخص",
  least_items: "الأقل عناصر",
};
